import { __assign } from "tslib";
import * as React from "react";
function SvgProjects(props) {
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M5.25 13.5h13V4.75h-7.367L9.15 3.5h-3.9v10z", stroke: "#566AE3", strokeWidth: 1.5, strokeLinejoin: "round" }),
        React.createElement("path", { d: "M1.75 16.5h13V7.75H7.383L5.65 6.5h-3.9v10z", fill: "#E6E5FA", stroke: "#566AE3", strokeWidth: 1.5, strokeLinejoin: "round" })));
}
export default SvgProjects;
//# sourceMappingURL=Projects.js.map